<template>
  <div class="w-100">
    <b-navbar type="light" class="p-3 header-novo-usuario">
      <b-navbar-nav
        class="w-100 d-flex justify-content-start align-items-center"
      >
        <b-nav-item class="btn-voltar text-white" to="/"
          ><font-awesome-icon
            icon="arrow-left"
            size="lg"
            style="color: #ffffff"
        /></b-nav-item>

        <b-nav-item href="#">
          <img
            src="../../assets/logo-tce.png"
            alt="Logo"
            style="height: 32px; filter: brightness(0) invert(1)"
          />
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>
<script lang="ts">
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { Component, Vue } from "vue-property-decorator";

const CompProps = Vue.extend({
  name: "HeaderNovoUsuario",
});

@Component
export default class HeaderNovoUsuario extends mixins(UtilsTS, CompProps) {}
</script>

<style scoped>
.btn-voltar {
  background: transparent;
  transition: background 0.2s;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  /* Deixa o texto em negrito */
}

.btn-voltar:hover {
  background: rgba(255, 255, 255, 0.25);
  cursor: pointer;
}

.header-novo-usuario {
  background-color: var(--baseColor);
}
</style>
